import { render, staticRenderFns } from "./bankruptcyManagerInput.vue?vue&type=template&id=636d66bc&scoped=true&"
import script from "./bankruptcyManagerInput.vue?vue&type=script&lang=js&"
export * from "./bankruptcyManagerInput.vue?vue&type=script&lang=js&"
import style0 from "./bankruptcyManagerInput.vue?vue&type=style&index=0&id=636d66bc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636d66bc",
  null
  
)

export default component.exports